(function () {
    'use strict';

    angular.module('app').factory('policyHolderService',policyHolderService);
    policyHolderService.$inject = ["$http", "$sessionStorage", "urlHelper", "handleException"];
    function policyHolderService($http, $sessionStorage, urlHelper, handleException) {
        var dataService = $http;

        return {

            getPolicyHolderDetails: function (email, policyNumber, postcode) {
                return dataService.get(urlHelper.getApiUrl() +
                        "Policyholder/GetPolicyHolderDetails?email=" + email + "&policyNumber=" + policyNumber + "&postcode=" + postcode)
                    .then(function (result) {
                        if (typeof result.data === 'object') {
                            var data = result.data;

                            return data;
                        }

                    },
                        function (error) {
                            handleException.log(error);
                            return error;
                        });

            },

            getPolicyHolderByOnlineUserLink: function(ProviderUserKey) {
                return dataService.get(urlHelper.getApiUrl() +
                        "Generic/GetRipePolicyHolderByOnlineUserLink?guid=" +
                        ProviderUserKey)
                    .then(function(result) {
                            if (typeof result.data === 'object') {
                                var data = result.data;

                                return data;
                            }

                        },
                        function(error) {
                            handleException.log(error);
                            return error;
                        });

            },

            getPolicyholderByMembershipId: function (membershipId) {

                return dataService.get(urlHelper.getApiUrl() +
                        "Generic/GetRipePolicyHolderByOnlineUserLink?guid=" +
                        membershipId)
                    .then(function(response) {
                        return response.data;
                    });

            },

            getMember: function (memberId) {
                return dataService.get(urlHelper.getApiUrl() +
                        "Generic/GetMember?memberId=" + memberId)
                    .then(function(response) {
                        return response.data;
                    });

            },

            createOnlineUserLink: function(userLink) {
                return dataService.post(urlHelper.getApiUrl() + "Generic/CreateOnlineUserLink", userLink)
                    .then(function(result) {
                            if (typeof result.data === 'object') {
                                var data = result.data;

                                return data;
                            }

                        },
                        function(error) {
                            handleException.log(error);
                            return error;
                        });

            },

            getCardDetails: function (policyId, policyHash) {

                var params = {
                    policyId: policyId,
                    policyHash: policyHash
                };

                var uri = "Policyholder/GetCardDetails";

                return dataService.get(urlHelper.getApiUrl() + uri, { params: params })
                   .then(function (result) {
                       if (typeof result.data === 'object') {
                           var data = result.data;

                           return data;
                       }

                   }, function (error) {
                       handleException.log(error);
                       return error;
                   });

            },

            getBankDetails: function (policyId, policyHash) {

                var params = {
                    policyId: policyId,
                    policyHash: policyHash
                };

                var uri = "Policyholder/GetBankDetails";

                return dataService.get(urlHelper.getApiUrl() + uri, { params: params })
                   .then(function (result) {
                       if (typeof result.data === 'object') {
                           var data = result.data;

                           return data;
                       }

                   }, function (error) {
                       handleException.log(error);
                       return error;
                   });

            },

            validatePolicyHolder: function (member, dob, email) {
                //dob needs to be in the format yyyy/mm/dd
                return dataService.get(urlHelper.getApiUrl() + "generic/ValidatePolicyHolder?email=" + email + "&dob=" + dob + "&member=" + member)
                    .then(function (result) {
                        return result;
                    },
                        function (error) {
                            handleException.log(error);
                        });


            },

            savePolicyHolder: function (request, handleException) {
                return dataService.post(urlHelper.getApiUrl() + "policyholder/SavePolicyHolder", request)
                    .then(function (result) {
                        if (typeof result.data === 'object') {
                            $sessionStorage.PolicyHolder = result.data;
                            return result;
                        }
                    }, function (error) {

                        handleException.log(error);
                    });
            }
        }

    }


})();